import PropTypes from 'prop-types';
import moment from 'moment';
import { getDuration, msToHMS } from '../../helpers';
import { NO_DATA } from '../../constants';

const ProjectWorkSessionLog = ({ worksessionList }) => {
  const capitalizeFirstLetter = (val) =>
    String(val).charAt(0).toUpperCase() + String(val).slice(1);
  return (
    <div className="table-responsive">
      {worksessionList && worksessionList.length > 0 ? (
        <table
          id="groupedDataByProject"
          className="table table-sm table-nowrap table-hover card-table"
        >
          <thead className="thead-light">
            <tr>
              <th>Team Member</th>
              <th>Original Worksession</th>
              <th>Updated Worksession</th>
              <th>Action</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {worksessionList.map((wsItem, index) => {
              const originalDuration = wsItem.oldCheckInDate
                ? getDuration(wsItem.oldCheckInDate, wsItem.oldCheckOutDate)
                : '';
              const newDuration = wsItem.newCheckInDate
                ? getDuration(wsItem.newCheckInDate, wsItem.newCheckOutDate)
                : '';
              return (
                <tr key={`wsEdit-${index}`}>
                  <td>{`${wsItem.teamMemberfirstName} ${
                    wsItem.teamMemberlastName || ''
                  }`}</td>
                  <td>
                    Duration: {msToHMS(originalDuration)}
                    <br />
                    Check-in: {moment(wsItem.oldCheckInDate).format('lll')}
                    <br />
                    Check-out: {moment(wsItem.oldCheckOutDate).format('lll')}
                  </td>
                  <td>
                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `Duration: ${msToHMS(newDuration)}`
                      : ''}
                    <br />
                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `Check-in: ${moment(wsItem.newCheckInDate).format(
                          'lll'
                        )}`
                      : ''}
                    <br />

                    {wsItem.updateType && wsItem.updateType !== 'delete'
                      ? `Check-out: ${moment(wsItem.newCheckOutDate).format(
                          'lll'
                        )}`
                      : ''}
                  </td>
                  <td>
                    {wsItem.updateType
                      ? `${capitalizeFirstLetter(
                          wsItem.updateType === 'edit'
                            ? `${wsItem.updateType}ed`
                            : `${wsItem.updateType}d`
                        )}`
                      : ''}{' '}
                    {`${
                      wsItem.updatedByFirstName
                        ? `by ${wsItem.updatedByFirstName}`
                        : ''
                    } ${wsItem.updatedByLastName || ''}`}
                  </td>
                  <td className="capitalize">{wsItem.reason}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <p className="m-4">{NO_DATA.WORKSESSION_EDIT_LOG}</p>
      )}
    </div>
  );
};

ProjectWorkSessionLog.propTypes = {
  worksessionList: PropTypes.array,
};

export default ProjectWorkSessionLog;
